import {
  fetchCheckinRewardsConfig,
  fetchConsecutiveDays,
  fetchCustomerCheckinRecords,
  fetchCustomerPrizeRecords,
  fetchGetAnnouncement,
} from '@/services';
import { toast } from '@/utils';
import dayjs from '@/utils/dayjs';
import { defineStore } from 'pinia';

interface State {
  /** 通告数据 */
  announcementData: AnyObject | null;
  homeCustomId: string; //首页自定义页面id
  classifyCustomId: string; //所有商品页自定义页面id
  activityCustomId: string; //活动页自定义页面id
  /** 签到数据相关配置 */
  signinConfig: {
    // 配置数据
    data: AnyObject | null;
    // 连签数据
    consecutives: { consecutiveDays: number; isCheckedIn: boolean };
    // 签到记录
    checkinRecords: AnyObject[];
    // 连签奖励
    prizeRecords: { eligiblePrizes: AnyObject[]; receivedPrizeRecords: AnyObject[] } | null;

    year: number;
    month: number;
  };
}

export const useCustomStore = defineStore('custom', {
  state: (): State => ({
    announcementData: null,
    homeCustomId: '',
    classifyCustomId: '',
    activityCustomId: '',
    signinConfig: {
      data: null,
      consecutives: { consecutiveDays: 0, isCheckedIn: false },
      checkinRecords: [],
      prizeRecords: null,
      year: new Date().getFullYear(),
      month: new Date().getMonth(),
    },
  }),
  getters: {},
  actions: {
    async getAnnouncement(refresh?: boolean) {
      if (!this.announcementData || refresh) {
        const data = await fetchGetAnnouncement();
        this.announcementData = data;
      }
      return this.announcementData;
    },
    async commonGetDataHandler(callback: () => Promise<void>) {
      const cancelLoading = toast.loading();
      await callback();
      cancelLoading();
    },
    async getCheckinRewardsConfig(refresh = false) {
      if (!this.signinConfig.data || refresh) {
        const res = await fetchCheckinRewardsConfig();
        console.log(`签到配置：`, res);
        if (res) {
          this.signinConfig.data = res;
        }
        return this.signinConfig.data;
      }
    },
    async getConsecutiveDays(refresh = false) {
      if (!this.signinConfig.consecutives || refresh) {
        const res = await fetchConsecutiveDays();
        console.log(`连签天数：`, res);
        if (res) {
          this.signinConfig.consecutives = res;
        }
        return this.signinConfig.consecutives;
      }
    },
    async getCheckinRecords(year: number, month: number, refresh = false) {
      if (!this.signinConfig.checkinRecords.length || refresh) {
        const res = await fetchCustomerCheckinRecords({ year, month });
        if (res) {
          this.signinConfig.checkinRecords = res.map((it: AnyObject) => {
            it._date = dayjs(it.checkinDate).date().toString();
            return it;
          });
        }
        console.log(`签到记录：`, this.signinConfig.checkinRecords);
        return this.signinConfig.checkinRecords;
      }
    },
    async getPrizeRecords(refresh = false) {
      if (!this.signinConfig.prizeRecords || refresh) {
        const res = await fetchCustomerPrizeRecords();
        console.log(`连签奖励：`, res);
        if (res) {
          this.signinConfig.prizeRecords = res;
        }
        return this.signinConfig.prizeRecords;
      }
    },
    async reupdateFetchFlows() {
      await this.getConsecutiveDays(true);

      await this.getPrizeRecords(true);

      const year = new Date().getFullYear();
      const month = new Date().getMonth();
      this.signinConfig.year = year;
      this.signinConfig.month = month;
      await this.getCheckinRecords(year, month, true);
    },
  },
});
